import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import DataTable from "react-data-table-component";

const EstimateMaterialSelectionModal = React.forwardRef((props, ref) => {
  const [disabled, setDisabled] = useState(true);
  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [getSelectedData, setSelectedData] = useState([]);
  // console.log(">>getSelectedData",getSelectedData)
// eslint-disable-next-line
  const toggleCardVisibility = () => { 
    setCardVisible(!isCardVisible);
  };

  const handleChangeCat = ({ selectedRows }) => {
    const updatedSelectedRows = selectedRows.map((row) => ({
      ...row,
    
    }));
    setSelectedData(updatedSelectedRows);
    setDisabled(selectedRows.length === 0);
  };

  // 🔹 Hardcoded Data instead of API
  useEffect(() => {
    const hardcodedData = [
      {
        code: "BUW5",
        description: "BUILTUP WEB PLATE 5MM",
        quantity: 0.5,
        pieceMeasure: 1,
        unit: "M",
        unitWeight: 19.625,
        unitPrice: 100,
        pieceWeight: 117.75,
        totalWeight: 117.75,
        price: 11775,
        totalPrice: 11775,
        unitWeightModifier: 1,
        unitPriceModifier: 1,
      },
      {
        code: "BUF8",
        description: "BUILTUP FLANGE PLATE 8MM",
        quantity: 0.15,
        pieceMeasure: 2,
        unit: "M",
        unitWeight: 9.42,
        unitPrice: 100,
        pieceWeight: 56.52,
        totalWeight: 113.04,
        price: 5652,
        totalPrice: 11304,
        unitWeightModifier: 1,
        unitPriceModifier: 1,
      },
    ];
    setData(hardcodedData);
  }, []);

  const handleSubmit = () => {
    console.log(">>getSelectedData123",getSelectedData)
    props.onselectedcatdata(getSelectedData);
    props.onHide();
  };

  const columns = [
    { name: "Code", selector: (row) => row.code, sortable: true },
    { name: "Description", selector: (row) => row.description, sortable: true },
    { name: "Quantity", selector: (row) => row.quantity, sortable: true },
    { name: "Piece Measure", selector: (row) => row.pieceMeasure, sortable: true },
    { name: "Unit", selector: (row) => row.unit, sortable: true },
    { name: "Unit Weight", selector: (row) => row.unitWeight, sortable: true },
    { name: "Unit Price", selector: (row) => row.unitPrice, sortable: true },
    { name: "Piece Weight", selector: (row) => row.pieceWeight, sortable: true },
    { name: "Total Weight", selector: (row) => row.totalWeight, sortable: true },
    { name: "Price", selector: (row) => row.price, sortable: true },
    { name: "Total Price", selector: (row) => row.totalPrice, sortable: true },
    { name: "Unit Wt. Modifier", selector: (row) => row.unitWeightModifier, sortable: true },
    { name: "Unit Price Modifier", selector: (row) => row.unitPriceModifier, sortable: true },
  ];

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      dialogClassName="modal-90w"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Material Selection</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12}>
            <DataTable
              columns={columns}
              data={data}
              selectableRows
              onSelectedRowsChange={handleChangeCat}
              pagination
            />
          </Col>
        </Row>

        <Row className="justify-end">
          <Col xs={6} md={2}>
            <button
              type="button"
              onClick={() => props.onHide()}
              className="btn btn-danger mt-4 w-full"
            >
              Cancel
            </button>
          </Col>
          <Col xs={6} md={2}>
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary mt-4 w-full"
              disabled={disabled}
            >
              Select
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default EstimateMaterialSelectionModal;
